import React from 'react'
import PropTypes from 'prop-types'

import { get } from 'utils/lodash'
import { getPaymentMethodImage, getPaymentMethodName } from 'utils/payment'
import { ListItem, ListItemIcon, ListItemText } from '@mui/material'

const PaymentMethodListItem = ({ nickNamePreference = false, method, ...rest }) => {
  const creditCardType = get(method, 'creditCardType', '')
  const accountType = get(method, 'accountType', '')
  const methodName = getPaymentMethodName(creditCardType, accountType)
  const methodImage = getPaymentMethodImage(creditCardType || methodName)
  const methodText =
    nickNamePreference && method?.cardNickName ? method.cardNickName : `${creditCardType || accountType} ends in ${method?.accountNumber}`

  return (
    <ListItem {...rest}>
      <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
        <img src={methodImage} alt="" />
      </ListItemIcon>
      <ListItemText primary={methodText} />
    </ListItem>
  )
}

PaymentMethodListItem.propTypes = {
  nickNamePreference: PropTypes.bool,
  method: PropTypes.object.isRequired,
}

export default PaymentMethodListItem
